import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { ReferAFriendIllustration } from '../..';

import BrandsBanner from './BrandsBanner';

import styles from './HeroReferrals.module.scss';

const HeroReferrals = ({ title = null, brandsBannerLayout = 'column' }) => {
  return (
    <div className={styles['hero-referrals']}>
      <div className={styles['hero-referrals__content']}>
        <h1 className={styles['hero-referrals__title']}>
          {trans('my-referrals.banner.title')}
        </h1>
        <h2 className={styles['hero-referrals__subtitle']}>
          {title || trans('my-referrals.banner.content')}
        </h2>

        <ReferAFriendIllustration
          className={styles['hero-referrals__image-mobile']}
        />

        <div className={styles['hero-referrals__brands-banner']}>
          <BrandsBanner rounded layout={brandsBannerLayout} />
        </div>
      </div>
      <ReferAFriendIllustration
        className={styles['hero-referrals__image-desktop']}
      />
    </div>
  );
};

HeroReferrals.propTypes = {
  title: PropTypes.string,
  brandsBannerLayout: PropTypes.oneOf(['column', 'row'])
};

export default HeroReferrals;
